import { isNumber } from 'lodash'

export * from './getAuditStatisticFromSubmissions'

export const kilogramsToTonnes = (number: number) =>
    isNumber(number) ? parseFloat(`${number / 1000}`).toFixed(2) : number
